import { render } from "./my-leaves.vue?vue&type=template&id=0b6dceb9&scoped=true"
import script from "./my-leaves.vue?vue&type=script&lang=js"
export * from "./my-leaves.vue?vue&type=script&lang=js"

import "./my-leaves.vue?vue&type=style&index=0&id=0b6dceb9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6dceb9"]])

export default __exports__